import Alpine from "alpinejs";

const referrer = !!document.referrer.match(/^https?:\/\/([^\/]+\.)?emk\.(at|ddev\.site)(\/|$)/i);

Alpine.data("historyBack", () => ({
    show: referrer,
    back() {
        history.back(-1);
    },
}));
